// JS
import React, { useState, useEffect } from 'react';
import { randomString } from '../shared/utils';
import { buildNuqliumProductQuery } from '../shared/logic';

// COMPS
import ProductRecommendations from '../ProductRecommendations';
import {
  recommendedProductsSeven,
  recommendedProductsSevenSale,
  bfNQFeed
} from '../shared/jsonData';
import ProductRecommendationsPopup from '../ProductRecommendationsPopup';

const devOrProd = process.env.REACT_APP_DEVORPROD;
const randomStringAll = randomString();

// COMPONENT
const ProductRecommendationsRecent = ({
  prodCode,
  userSession,
  currency,
  useURLParameter,
  blackFriday,
  data,
  isSale
}) => {
  const [prodRecs, setProdRecs] = useState(null);
  const [prodRecsSale, setProdRecsSale] = useState(null);
  const [prodRecsRecent, setProdRecsRecent] = useState(null);
  const [bfFeed, setBfFeed] = useState(null);

  // Quick View
  const [showHideQuickView, setShowHideQuickView] = useState(false);
  const [quickViewProdId, setQuickViewProdId] = useState(null);
  const [, setSelected] = useState(null);

  // Product Recommendations
  /*
  useEffect(() => {
    if (prodCode) {
      recommendedProductsSeven.endPointPrams.append('pagevalue', prodCode);

      fetch(recommendedProductsSeven.endPointUrl, {
        method: 'POST',
        body: recommendedProductsSeven.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          setProdRecs(data);
        });
    }
  }, [prodCode]);
  */

  //BlackFriday Feed
  useEffect(() => {
    if (blackFriday) {
      fetch(bfNQFeed.endPointUrl, {
        method: 'POST',
        body: bfNQFeed.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          setBfFeed(data);
        });
    }
  }, [blackFriday]);

  // Recently Viewed
  useEffect(() => {
    if (window.localStorage.getItem('nuqlium.products')) {
      console.log(
        'CookieProducts:',
        window.localStorage.getItem('nuqlium.products')
      );
      const getFormData = (object) => {
        const formData = new FormData();
        Object.keys(object).forEach((key) => formData.append(key, object[key]));
        return formData;
      };

      const apiQuery = {
        endPointUrl:
          'https://support.footasylum.co.uk/api/nuqlium-seven/data/' +
          devOrProd +
          '/index.php/?v=' +
          randomStringAll,
        endPointPrams: getFormData(
          buildNuqliumProductQuery(
            window.localStorage.getItem('nuqlium.products') || [
              '4082093',
              '4082890',
              '4081079',
              '4080398',
              '4089259',
              '4077806',
              '4077811',
              '4058566',
              '4076218',
              '4089747',
              '4089757',
              '4089761',
              '4089760',
              '4076251',
              '4089516',
              '4076309',
              '4076300',
              '4076275',
              '4078887',
              '4081534'
            ]
          )
        )
      };

      fetch(apiQuery.endPointUrl, {
        method: 'POST',
        body: apiQuery.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          setProdRecsRecent(data);
        });
    }
  }, []);

  return (
    <>
      {showHideQuickView && (
        <ProductRecommendationsPopup
          quickViewProdId={quickViewProdId}
          setQuickViewProdId={setQuickViewProdId}
          showHideQuickView={showHideQuickView}
          setShowHideQuickView={setShowHideQuickView}
          setSelected={setSelected}
          userSession={userSession}
          useURLParameter={useURLParameter}
        />
      )}

      <section className={'product-recommendations-recently-viewed'}>
        <div className="product-recommendations-recently-viewed-content">
          {blackFriday && (
            <div className="product-recommendations-content">
              <ProductRecommendations
                prodRecsTitle={'Black Friday Edit'}
                blackFriday={blackFriday}
                simpleData={bfFeed}
                currency={currency}
                showHideQuickView={showHideQuickView}
                setQuickViewProdId={setQuickViewProdId}
                setShowHideQuickView={setShowHideQuickView}
              />
            </div>
          )}
          {isSale && data.product.option.onsale && (
            <div className="product-recommendations-content mon-recs-sale">
              {prodCode && (
                <ProductRecommendations
                  prodRecsTitle={'Sale Edit'}
                  simpleData={prodRecsSale}
                  currency={currency}
                  showHideQuickView={showHideQuickView}
                  setQuickViewProdId={setQuickViewProdId}
                  setShowHideQuickView={setShowHideQuickView}
                  isSale={true}
                  prodCode={prodCode}
                  recsID={recommendedProductsSevenSale}
                  setProdRecs={setProdRecsSale}
                />
              )}
            </div>
          )}
          <div className="product-recommendations-content mon-recs-normal">
            {prodCode && (
              <ProductRecommendations
                prodRecsTitle={'You may also like'}
                simpleData={prodRecs}
                currency={currency}
                showHideQuickView={showHideQuickView}
                setQuickViewProdId={setQuickViewProdId}
                setShowHideQuickView={setShowHideQuickView}
                prodCode={prodCode}
                recsID={recommendedProductsSeven}
                setProdRecs={setProdRecs}
              />
            )}
          </div>
          <div className="product-recommendations-content">
            {prodRecsRecent && (
              <ProductRecommendations
                prodRecsTitle={'Recently Viewed'}
                simpleData={prodRecsRecent}
                currency={currency}
                showHideQuickView={showHideQuickView}
                setQuickViewProdId={setQuickViewProdId}
                setShowHideQuickView={setShowHideQuickView}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductRecommendationsRecent;
